import { FlowNavigationContext, FlowPage } from "../shared/constants";

/**
 * Returns the previous eligible page (ignores browser history).
 * Used to drive the "Back" button.
 * Ensures users never land on transitional pages when navigating backwards.
 * @param currentSlug - The current page slug
 * @param context - The information we pass into each requirement so it can
 *                  perform its validation
 * @returns The previous eligible page slug, or null if no previous page is found
 */
export function getPreviousPageSlug<T extends string = never>(
  currentSlug: string,
  context: FlowNavigationContext,
  flowPages: FlowPage<T>[]): T | null {
  const currentPageIndex = flowPages.findIndex((page) => page.slug === currentSlug);

  if (currentPageIndex === -1) {
    return null;
  }

  for (let i = currentPageIndex - 1; i >= 0; i -= 1) {
    const page = flowPages[i];
    const isVisible = page.accessRequirements.every((req) => req(context));

    if (isVisible && !page.isTransitionScreen) {
      return page.slug;
    }
  }

  return null;
}
